import React, { Children } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { withStateHandlers, defaultProps, compose } from 'recompose';

import { SFIcon } from 'components/core/SFIcon';
import { Button } from 'components/core/Button';
import DotControl from './DotControl';

import './carousel.scss';

export const enhance = compose(
	defaultProps({
		children: [],
		slideShowing: 0
	}),
	withStateHandlers(({ slideShowing }) => ({ slideShowing }), {
		handleNext: ({ slideShowing }, { children }) => () => {
			if (slideShowing + 1 < children.length) {
				return { slideShowing: slideShowing + 1 };
			}
			// back to the beginning
			return { slideShowing: 0 };
		},
		handlePrevious: ({ slideShowing }, { children }) => () => {
			if (slideShowing - 1 >= 0) {
				return { slideShowing: slideShowing - 1 };
			}
			// back to end
			return { slideShowing: children.length - 1 };
		},
		handleSlideDot: () => (dotIndex) => ({ slideShowing: dotIndex })
	})
);

export function Carousel({
	children,
	slideShowing,
	handleNext,
	handlePrevious,
	handleSlideDot,
	className
}) {
	return (
		<div className={classnames('ph-carousel', className)}>
			{Children.toArray(children).length > 1 &&
				<div className="controls-overlay">
					<Button
						onClick={handlePrevious}
						className="control-button control-left"
						primary={false}
					>
						<SFIcon
							className="control-arrow"
							icon="chevron-left"
						/>
					</Button>
					<Button
						onClick={handleNext}
						className="control-button control-right"
						primary={false}
					>
						<SFIcon
							className="control-arrow"
							icon="chevron-right"
						/>
					</Button>
					<ul className="image-dots">
						{Children.toArray(children).map((slide, index) => (
							<DotControl
								key={slide.key}
								index={index}
								onClick={handleSlideDot}
								slideShowing={slideShowing === index}
							/>
						))}
					</ul>
				</div>
			}
			<div className="carousel-window">
				{Children.toArray(children).map((slide, index) => (
					<div
						key={slide.key}
						className={
							classnames('carousel-content', { selected: index === slideShowing })
						}
					>
						{slide}
					</div>
				))}
			</div>
		</div>
	);
}

Carousel.propTypes = {
	/** Additional class name to be applied to the component */
	className: PropTypes.string,
	children: PropTypes.node,
	handleNext: PropTypes.func,
	handlePrevious: PropTypes.func,
	handleSlideDot: PropTypes.func,
	slideShowing: PropTypes.number
};

Carousel.defaultProps = {
	children: []
};

export default enhance(Carousel);
